import avator12 from "../assets/agent/12.png";
import avator13 from "../assets/agent/13.png";
import avator14 from "../assets/agent/14.png";
import avator15 from "../assets/agent/15.png";
import avator16 from "../assets/agent/16.png";
import avator17 from "../assets/agent/17.png";
import avator18 from "../assets/agent/18.png";
import avator19 from "../assets/agent/19.png";
import avator20 from "../assets/agent/20.png";
import avator21 from "../assets/agent/21.png";
import avator22 from "../assets/agent/22.png";
import avator23 from "../assets/agent/23.png";
import avator24 from "../assets/agent/24.png";
import avator25 from "../assets/agent/25.png";
import avator2 from "../assets/agent/avator-02.png";
import avator3 from "../assets/agent/avator-03.png";
import avator4 from "../assets/agent/avator-04.png";
import avator5 from "../assets/agent/avator-05.png";
import avator6 from "../assets/agent/avator-06.png";
import avator8 from "../assets/agent/avator-08.png";
import avator9 from "../assets/agent/avator-09.png";
import avator10 from "../assets/agent/avator-10.png";
import avator1 from "../assets/agent/avator_blue.png";
import avator11 from "../assets/agent/avator-male.png";
 
 

export const PROJECT_LOCASTORAGE_NAME = "currentProjectId"
export const PROJECT_ID_FIELD = "projectId"


export const AVATOR_LIST = [
    avator1,
    avator2,
    avator3,
    avator4,
    avator5,
    avator6,
    avator8,
    avator9,
    avator10,
    avator11,
    avator12,
    avator13,
    avator14,
    avator15,
    avator16,
    avator17,
    avator18,
    avator19,
    avator20,
    avator21,
    avator22,
    avator23,
    avator24,
    avator25,
]